import React from "react";
import { useField } from "formik";
import { Checkbox, FormField } from "semantic-ui-react";

export default function MyCompanyWebsiteLinkInput({
  label,
  showError = true,
  showHighlightError = true,
  errorClasses = "error-message",
  isDisabled = false,
  ...props
}) {
  const [field, meta, helpers] = useField(props);

  function handleTypeChange(e, { value }) {
    helpers.setValue({
      url: field.value["url"],
      isApply: value === 1,
    });
  }

  function handleChange(e) {
    helpers.setValue({
      url: e.target.value,
      isApply: true,
    });
  }

  return (
    <FormField
      style={{ marginTop: 10, marginBottom: 10 }}
      error={showHighlightError && meta.touched && !!meta.error}
      disabled={isDisabled}
    >
      <label>{label}</label>
      <input
        {...field}
        {...props}
        className="form-input-field"
        value={field.value["url"] || ""}
        placeholder="Company website link (e.g. careers page)"
        onChange={(e) => handleChange(e)}
      />
      {showError && meta.touched && meta.error ? (
        <div className={errorClasses}>{meta.error["url"]}</div>
      ) : null}
      {field.value["url"] !== "" && !meta.error && (
        <div
          className="body-blue-text"
          style={{
            marginTop: 5,
            padding: "11px 11px 11px 16px",
            backgroundColor: "rgba(188, 224, 253, 0.14)",
            borderRadius: 12,
            border: "1px solid #BCE0FD",
          }}
        >
          <div>Can Job Seekers apply via this website?</div>
          <div style={{ margin: "8px 0 4px" }}>
            <Checkbox
              radio
              name="checkboxRadioGroup"
              value={1}
              checked={field.value["isApply"]}
              onChange={handleTypeChange}
              label={{
                children: <span className="body-blue-text">Yes</span>,
              }}
            />
          </div>
          <div>
            <Checkbox
              radio
              name="checkboxRadioGroup"
              value={0}
              checked={!field.value["isApply"]}
              onChange={handleTypeChange}
              label={{
                children: <span className="body-blue-text">No</span>,
              }}
            />
          </div>
        </div>
      )}
    </FormField>
  );
}
